<template>
  <div>
    <el-tabs type="card">
      <!-- chalans tab -->
      <el-tab-pane label="Chalans">
        <div class="col-md-4 offset-md-8">
          <base-button
            size="sm"
            style="margin-left: 180px"
            type="primary"
            @click="openChalanDialog"
          >
            Add Chalan
          </base-button>
        </div>
        <div class="row chalan-list">
          <el-table
            :data="serviceRequestChalansList"
            style="width: 100%"
            row-key="serviceRequestChalanId"
          >
            <el-table-column type="expand">
              <template slot-scope="scope">
                <div
                  v-if="
                    scope.row.chalanItems && scope.row.chalanItems.length > 0
                  "
                  class="row"
                >
                  <div
                    v-for="(item, index) in scope.row.chalanItems"
                    :key="index"
                    class="chalan-details col-md-4"
                  >
                    <div class="chalan-item">
                      <label>Product Name :</label>
                      <span>{{ item.name }}</span>
                    </div>
                    <div class="chalan-item">
                      <label>Quantity :</label>
                      <span>{{ item.quantity }}</span>
                    </div>
                  </div>
                </div>
                <div v-else class="row">
                  <div style="padding-left: 60px">
                    <label>Please Try Again!</label>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column type="index" label="#" />
            <el-table-column prop="updatedAt" label="Date">
              <template slot-scope="scope"
                >{{ scope.row.updatedAt | dateFormat }}
              </template>
            </el-table-column>
            <el-table-column prop="chalanNumber" label="Chalan Number" />
            <el-table-column prop="isInward" label="Type">
              <template slot-scope="scope"
                >{{ scope.row.isInward | convertType }}
              </template>
            </el-table-column>
            <el-table-column prop="status" label="Status">
              <template slot-scope="scope">
                <span v-if="scope.row.status">
                  <el-tag
                    v-if="scope.row.status.code === 'pending'"
                    class="pending-status"
                    effect="dark"
                    >{{ scope.row.status.label }}</el-tag
                  >
                  <el-tag
                    v-else-if="scope.row.status.code === 'dispatched'"
                    class="dispatch-status"
                    effect="dark"
                    >{{ scope.row.status.label }}</el-tag
                  >
                  <el-tag
                    v-else-if="scope.row.status.code === 'accepted'"
                    type="success"
                    effect="dark"
                    >{{ scope.row.status.label }}</el-tag
                  >
                </span>
              </template>
            </el-table-column>
            <el-table-column label="Actions">
              <template slot-scope="scope">
                <base-button
                  v-if="scope.row.status.code === 'dispatched'"
                  size="sm"
                  @click="updateChalan(scope.row)"
                  >Accept</base-button
                >
                <span v-else>No Actions</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <!-- external goods tab -->
      <el-tab-pane label="External Goods">
        <div class="col-md-6 offset-md-8">
          <base-button
            v-if="
              serviceRequest.externalGoodsMeta &&
                serviceRequest.externalGoodsMeta.length
            "
            style="margin-left: 117px"
            size="sm"
            type="primary"
            @click="updateExternalGood(serviceRequest.externalGoodsMeta)"
            >Add/Edit External Goods</base-button
          >
          <base-button
            v-else
            style="margin-left: 117px"
            size="sm"
            type="primary"
            @click="openExternalGoodsDialog()"
          >
            Add External Goods
          </base-button>
        </div>
        <div class="row chalan-list">
          <el-table
            v-if="
              serviceRequest.externalGoodsMeta &&
                serviceRequest.externalGoodsMeta.length > 0
            "
            :data="serviceRequest.externalGoodsMeta"
            style="width: 100%"
          >
            <el-table-column type="index" label="#" />
            <el-table-column label="Name" prop="name" />
            <el-table-column label="Quantity" prop="quantity" />
            <el-table-column label="Total" prop="total" />
            <el-table-column label="Type" prop="type">
              <template slot-scope="scope">
                {{ scope.row.type | modifyType }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- chalan dialog -->
    <el-dialog :visible.sync="showChalan" title="Add Chalan">
      <div class="row">
        <div class="col-md-6">
          <base-input label="Inward Chalan?">
            <el-radio
              v-model="serviceRequestChalan.isInward"
              :label="true"
              @change="fetchServiceRequestProducts"
            >
              Yes
            </el-radio>
            <el-radio v-model="serviceRequestChalan.isInward" :label="false">
              No
            </el-radio>
          </base-input>
        </div>
        <div class="col-md-6">
          <div style="float: right; margin-top: 20px">
            <base-button
              type="primary"
              size="sm"
              @click="handleChalanProductAdd()"
              >Add New</base-button
            >
          </div>
        </div>
      </div>
      <el-table :data="serviceRequestChalan.chalanItems">
        <el-table-column label="Product Name">
          <template slot-scope="scope">
            <base-input>
              <el-autocomplete
                v-uppercase
                ref="searchProduct"
                v-model="scope.row.name"
                :fetch-suggestions="suggestProducts"
                :trigger-on-focus="false"
                popper-class="product-search"
                placeholder="Type..."
                tabindex="4"
                value-key="name"
                @focus="setCurrentRow(scope.row)"
                @select="handleProductSelect"
              >
                <template slot-scope="{ item }">
                  <div class="value">{{ item.name }}</div>
                </template>
              </el-autocomplete>
            </base-input>
          </template>
        </el-table-column>
        <el-table-column label="Qty." min-width="40">
          <template slot-scope="scope">
            <base-input v-model="scope.row.quantity" />
          </template>
        </el-table-column>
        <el-table-column label="Actions" min-width="40">
          <template slot-scope="scope">
            <el-button
              style="margin-bottom: 20px"
              size="mini"
              type="danger"
              @click="handleChalanProductDelete(scope.$index)"
            >
              <i class="el-icon-delete" />
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showChalan = false">Cancel</el-button>
        <el-button type="primary" @click="addChalan()"> Confirm </el-button>
      </span>
    </el-dialog>
    <!-- external goods dialog -->
    <el-dialog
      :visible.sync="openGoodsDialog"
      title="Add External Goods.."
      width="60%"
    >
      <div class="row" style="margin-bottom: 10px">
        <div class="col-md-6">
          <base-button type="primary" size="sm" @click="handleExternalGoodAdd()"
            >Add New</base-button
          >
        </div>
      </div>
      <el-table :data="externalGoodsMeta">
        <el-table-column label="Name">
          <template slot-scope="scope">
            <base-input v-uppercase v-model="scope.row.name" />
          </template>
        </el-table-column>
        <el-table-column label="Qty.">
          <template slot-scope="scope">
            <base-input v-model="scope.row.quantity" type="number" />
          </template>
        </el-table-column>
        <el-table-column label="Total">
          <template slot-scope="scope">
            <base-input v-model="scope.row.total" type="number" />
          </template>
        </el-table-column>
        <el-table-column label="Type">
          <template slot-scope="scope">
            <el-radio v-model="scope.row.type" label="external"
              >External</el-radio
            >
            <el-radio v-model="scope.row.type" label="internal"
              >Internal</el-radio
            >
          </template>
        </el-table-column>
        <el-table-column min-width="50">
          <template slot-scope="scope">
            <el-button
              style="margin-bottom: 20px"
              size="mini"
              type="danger"
              @click="handleExternalGoodDelete(scope.$index)"
            >
              <i class="el-icon-delete" />
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clearExternalGoods()">Cancel</el-button>
        <el-button type="primary" @click="addExternalGoods()">
          Confirm
        </el-button>
      </span></el-dialog
    >
  </div>
</template>

<script>
import dateFns from "date-fns";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import {
  Dialog,
  Button,
  Table,
  TableColumn,
  Autocomplete,
  Select,
  Option,
  Input,
  Radio,
  Tag,
  Tabs,
  TabPane
} from "element-ui";
export default {
  directives: {
    uppercase: {
      inserted: function(el, _, vnode) {
        el.addEventListener("input", async function(e) {
          const modified = e.target.value
            .split(" ")
            .map(i => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      }
    }
  },
  components: {
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Autocomplete.name]: Autocomplete,
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Radio.name]: Radio,
    [Tag.name]: Tag,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane
  },
  filters: {
    dateFormat(value) {
      return dateFns.format(new Date(value), "DD MMM YYYY");
    },
    convertType(value) {
      if (value === true) {
        return "Inward Chalan";
      } else {
        return "Outward Chalan";
      }
    },
    modifyType(value) {
      const modified = value
        .split(" ")
        .map(i => i.charAt(0).toUpperCase() + i.slice(1))
        .join(" ");
      return modified;
    },
    currency(value) {
      const amount = parseFloat(value) || 0;
      const a = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR"
      }).format(amount);
      return a.replace(".00", "");
    }
  },
  data() {
    return {
      amount: 0,
      showChalan: false,
      currentRow: {},
      serviceRequestProducts: [],
      openGoodsDialog: false,
      activeName: "first",
      externalGoodsMeta: [
        {
          name: "",
          quantity: "",
          total: "",
          type: "external"
        }
      ]
    };
  },

  computed: {
    ...mapState("serviceRequestChalan", [
      "serviceRequestChalan",
      "serviceRequestChalansList"
    ]),
    ...mapState("serviceRequest", ["serviceRequest"]),
    ...mapState("serviceRequestLabor", ["serviceRequestLabors"]),
    ...mapGetters({
      statusList: "status/getStatusList",
      serviceRequestQuotations:
        "serviceRequestQuotation/getServiceRequestQuotationList"
    })
  },

  mounted() {
    this.getServiceRequest(this.$route.params.id);
    this.getServiceRequestChalans(this.$route.params.id);
    if ((this.serviceRequest.externalGoodsMeta = {})) {
      this.serviceRequest.externalGoodsMeta = [
        {
          name: "",
          quantity: null,
          total: null,
          type: "external"
        }
      ];
    }
  },
  methods: {
    ...mapActions({
      getProducts: "product/getProducts",
      getProduct: "product/getProduct",
      getPaymentModes: "paymentMode/getPaymentModes",
      saveServiceRequestChalan: "serviceRequestChalan/saveServiceRequestChalan",
      getServiceRequestChalans: "serviceRequestChalan/getServiceRequestChalans",
      fetchServiceRequest: "serviceRequest/fetchServiceRequest",
      updateServiceRequestChalan:
        "serviceRequestChalan/updateServiceRequestChalanData",
      addExternalGoodsData: "serviceRequest/addExternalGoodsData",
      getServiceRequest: "serviceRequest/fetchServiceRequest"
    }),

    ...mapMutations({
      resetServiceRequestChalan:
        "serviceRequestChalan/resetServiceRequestChalan"
    }),

    /* --------- chalans related functions ----------- */
    openChalanDialog() {
      // checking if sale invoice is generated and if status is completed
      if (
        this.serviceRequest.saleId ||
        this.serviceRequest.status.code === "completed"
      ) {
        this.$notify({
          message:
            "You Can Not Add Chalan After Generating Invoice or with completed status!",
          type: "danger",
          title: "Failure"
        });
      } else {
        this.resetServiceRequestChalan();
        this.showChalan = true;
      }
    },
    addChalan() {
      const status = this.statusList.filter(i => i.code === "pending");
      this.serviceRequestChalan.statusId = status[0].statusId;
      this.serviceRequestChalan.createdBy = this.serviceRequest.vendorId;
      this.saveServiceRequestChalan(this.$route.params.id)
        .then(() => {
          this.getServiceRequestChalans(this.$route.params.id);
          this.showChalan = false;
          this.$notify({
            message: "Chalan Added Succesfully!",
            type: "success",
            title: "Success"
          });
        })
        .catch(() => {
          this.$notify({
            message: "Try Again!",
            type: "danger",
            title: "Failure"
          });
        });
    },
    async suggestProducts(query, cb) {
      if (this.serviceRequestChalan.isInward === true) {
        cb(this.serviceRequestProducts);
      } else {
        const result = await this.getProducts({ searchKeyword: query });
        cb(result.rows);
      }
    },
    handleChalanProductAdd() {
      this.serviceRequestChalan.chalanItems.push({
        name: "",
        quantity: 1
      });
    },
    handleChalanProductDelete(index) {
      this.serviceRequestChalan.chalanItems.splice(index, 1);
    },
    handleProductSelect(item) {
      this.currentRow.productId = item.productId;
      this.currentRow.taxRate = item.tax.rate;
    },
    setCurrentRow(row) {
      this.currentRow = row;
    },
    fetchServiceRequestProducts() {
      if (this.serviceRequestChalan.isInward === true) {
        let acceptedChalanProducts = [];
        this.serviceRequestChalansList.forEach(i => {
          if (i.status.code === "accepted") {
            acceptedChalanProducts.push(...i.chalanItems);
          }
        });
        acceptedChalanProducts.forEach(async i => {
          const product = await this.getProduct(i.productId);
          this.serviceRequestProducts.push({
            productId: i.productId,
            quantity: i.quantity,
            name: product.name,
            tax: product.tax
          });
        });
        if (acceptedChalanProducts.length <= 0) {
          this.$notify({
            message: "Cannot Inward Chalan!",
            type: "danger",
            title: "Failure"
          });
        }
      }
    },
    updateChalan(data) {
      const newStatus = this.statusList.find(i => i.code === "accepted");
      this.updateServiceRequestChalan({
        statusId: newStatus.statusId,
        serviceRequestChalanId: data.serviceRequestChalanId,
        serviceRequestId: this.$route.params.id
      }).then(() => {
        this.getServiceRequestChalans(this.$route.params.id);
        this.$notify({
          message: "Chalan Updated Succesfully!",
          type: "success",
          title: "Success"
        });
      });
    },

    /* --------- external goods related functions ----------- */

    openExternalGoodsDialog() {
      // checking if vendor invoice is generated and if status is completed
      if (
        this.serviceRequest.vendorInvoice ||
        this.serviceRequest.status.code === "completed"
      ) {
        this.$notify({
          message:
            "You Can Not Add External Good After Generating Invoice or with completed status!",
          type: "danger",
          title: "Failure"
        });
      } else {
        this.openGoodsDialog = true;
        this.resetExternalGoods();
      }
    },
    resetExternalGoods() {
      this.externalGoodsMeta = [
        {
          name: "",
          quantity: null,
          total: null,
          type: "external"
        }
      ];
    },

    handleExternalGoodDelete(index) {
      this.externalGoodsMeta.splice(index, 1);
    },
    handleExternalGoodAdd() {
      this.externalGoodsMeta.push({
        name: "",
        quantity: null,
        total: null,
        type: "external"
      });
    },
    addExternalGoods() {
      let list = [];
      this.externalGoodsMeta.forEach(i => {
        if (i.name && i.quantity && i.total > 0) {
          list.push({
            name: i.name,
            quantity: parseInt(i.quantity),
            total: parseFloat(i.total),
            type: i.type
          });
        }
      });
      this.addExternalGoodsData({
        externalGoodsMeta: list
      })
        .then(() => {
          this.openGoodsDialog = false;
          this.resetExternalGoods();
          this.$notify({
            message: "External Good/s Added Successfully!",
            type: "success",
            title: "Success"
          });
        })
        .catch(() => {
          this.$notify({
            message: "Try Again!",
            type: "danger",
            title: "Failure"
          });
        });
    },
    updateExternalGood(goods) {
      // checking if vendor invoice is generated and if status is completed
      if (
        this.serviceRequest.vendorInvoice ||
        this.serviceRequest.status.code === "completed"
      ) {
        this.$notify({
          message:
            "You Can Not Add External Good After Generating Invoice or with completed status!",
          type: "danger",
          title: "Failure"
        });
      } else {
        this.externalGoodsMeta = [];
        for (const i of goods) {
          this.externalGoodsMeta.push({
            name: i.name,
            quantity: i.quantity,
            total: i.total,
            type: i.type
          });
        }
        this.openGoodsDialog = true;
      }
    },
    clearExternalGoods() {
      this.openGoodsDialog = false;
      this.externalGoodsMeta = [];
      this.externalGoodsMeta.push({
        name: "",
        quantity: null,
        total: null,
        type: "external"
      });
    }
  }
};
</script>

<style>
.chalan-list {
  margin-top: 20px;
  margin-bottom: 90px;
}
.chalan-details {
  display: flex;
  flex-direction: column;
  margin-left: 30px;
}
.chalan-item {
  display: flex;
}
.chalan-item label {
  font-weight: 600;
  font-size: 13px;
  margin-right: 4px;
}
.card .advance-amount-card {
  border: 0 1px;
}
.advance-amount-card .advance-body {
  margin: 10px;
}
.advance-footer {
  margin-left: 88%;
}
.approx-product-remove-item {
  margin-left: 60px;
  margin-top: -26px;
  font-size: 25px;
  cursor: pointer;
}
.product-search {
  width: 267px !important;
}
.pending-status {
  background-color: #e72626;
  border-color: #e72626;
  color: #fff;
}
.dispatch-status {
  background-color: #f57316eb;
  border-color: #f57316eb;
  color: #fff;
}
</style>
